import { makeSingleton } from '@encodable/registry';
import ColorNamespaceRegistry from './ColorNamespaceRegistry';
import stringifyAndTrim from '../utils/stringifyAndTrim';
export const getColorNamespaceRegistry = makeSingleton(() => new ColorNamespaceRegistry({
  globalId: '@encodable/color:ColorNamespaceRegistry'
}));
export function getColorNamespace(namespace) {
  return getColorNamespaceRegistry().get(namespace);
}
export function getScale(scheme, namespace) {
  return getColorNamespaceRegistry().get(namespace).getScale(scheme);
}
export function getColor(value, scheme, namespace) {
  return getColorNamespaceRegistry().get(namespace).getScale(scheme)(stringifyAndTrim(value));
}
export { ColorNamespaceRegistry };